import axios from "axios";
import { useEffect, useState } from "react";
import { format } from "date-fns";
const Approved = ({ id }) => {
  const [approvedLeave, setApprovedLeave] = useState("");
  const [singleApprovedLeave, setSingleApprovedLeave] = useState("");
  const [leaveDetails, setLeaveDetails] = useState(null);

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let myEmployeeId = null;
  const getLeaveDetailsByEmployeeId = async (employeeId) => {
    try {
      const response = await axios.get(`${apiUrl}/leave/detailsEmpID/${employeeId}`);
      setLeaveDetails(response.data.data); // Update state with fetched data
      console.log("Leave details fetched from API:", response.data.data); // Log the fetched data directly
    } catch (error) {
      console.error("Error fetching leave details by Employee ID:", error);
    }
  };
  const getApprovedApplications = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/leave/detailsByLeaveID/${id}`
      );
      console.log(response.data.leaves || []);
      setApprovedLeave(response.data.leaves);
    } catch (error) {
      console.log([]);
    }
  };
  const getSingleApprovedApplications = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/employee/${approvedLeave.EmployeeID}`
      );
      console.log(response.data.employeeInfo);
      setSingleApprovedLeave(response.data.employeeInfo);
    } catch (error) {
      console.log(error);
    }
  };
  console.log(approvedLeave.Total);

    // Fetch leave details when approvedLeave.EmployeeID changes
    useEffect(() => {
      if (approvedLeave.EmployeeID) {
        getLeaveDetailsByEmployeeId(approvedLeave.EmployeeID);
      }
    }, [approvedLeave.EmployeeID]);
  useEffect(() => {
    getSingleApprovedApplications();
  }, [approvedLeave.EmployeeID]);
  useEffect(() => {
    getApprovedApplications();
  }, [id]);

  const remainingLeave = leaveDetails?.remainingLeaves;

  return (
    <div className="p-5">
      <div className="flex flex-col flex-wrap lg:flex-row gap-6 md:divide-x md:divide-gray-200">
        {/*FIRST-SECTION APPLICATION*/}

        <div className="flex-1 px-4">
          {/* Content for the first section */}
          <h2 className="text-base font-semibold mb-4 text-gray-800">Application Details</h2>

          <div className="space-y-3">
            <p className="text-sm"><span className="font-medium text-gray-700">Name:</span> <span className="text-gray-900">{approvedLeave.Name}</span></p>

            <p className="text-sm">
              <span className="font-medium text-gray-700">Applied Date:</span> <span className="text-gray-900">{approvedLeave.DateApplied}</span>
            </p>

            <div>
              <p className="text-sm font-medium text-gray-700 mb-1">Leave Dates:</p>
              {approvedLeave.Date ? (
                <ul className="text-sm text-gray-900 ml-4 space-y-1">
                  {JSON.parse(approvedLeave.Date).map((date, index) => (
                    <li key={index} className="list-disc">{format(new Date(date), "yyyy-MM-dd")}</li>
                  ))}
                </ul>
              ) : (
                <span className="text-sm text-gray-500">No leave dates available.</span>
              )}
            </div>

            <p className="text-sm"><span className="font-medium text-gray-700">Cause:</span> <span className="text-gray-900">{approvedLeave.Cause}</span></p>

            <p className="text-sm">
              <span className="font-medium text-gray-700">Leave Type:</span> <span className="text-gray-900">{approvedLeave.Type}</span>
            </p>

            <p className="text-sm">
              <span className="font-medium text-gray-700">Address:</span> <span className="text-gray-900">{approvedLeave.Address}</span>
            </p>

            <p className="text-sm">
              <span className="font-medium text-gray-700">Contact:</span> <span className="text-gray-900">{approvedLeave.Contact}</span>
            </p>
          </div>
        </div>

        {/* SECOND-SECTION LEAVE STATUS */}

        <div className="flex-1 px-4">
          {/* Content for the second section */}
          <h2 className="text-base font-semibold mb-4 text-gray-800">Leave Status</h2>
          <div className="flex mb-3">
            <p className="text-sm font-medium text-gray-700">Type: </p>
            <p className="text-sm font-semibold text-gray-900 ml-2">
              {approvedLeave.Type === "Sick" ? "Sick Leave" : "Casual Leave"}
            </p>
          </div>

          <table className="min-w-full text-sm border border-gray-200 rounded-lg">
            <thead className="border-b bg-gray-50">
              <tr>
                <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Total</th>
                <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Taken</th>
                <th scope="col" className="px-4 py-2.5 text-center font-medium text-gray-700">Due</th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center border-b">
                <td className="px-4 py-2.5 bg-blue-50 font-medium">16</td>
                <td className="px-4 py-2.5 bg-green-50 font-medium">
                  {leaveDetails?.remainingLeaves?.TotalLeave - leaveDetails?.remainingLeaves?.TotalDue || 0}
                </td>
                <td className="px-4 py-2.5 bg-green-50 font-medium">
                  {leaveDetails?.remainingLeaves?.TotalDue || 0}
                </td>
              </tr>
            </tbody>
          </table>

          <p className="text-sm text-gray-800 mt-3 font-medium">
            Current Request: {approvedLeave.Total} days
          </p>
        </div>

        {/* THIRD SECTION GIVE APPROVAL */}
        <div className="flex-1 px-4">
          <h2 className="text-base font-semibold mb-4 text-gray-800">Status</h2>

          <div className="flex text-sm items-center space-x-2 text-green-700 bg-green-50 p-4 rounded-lg border border-green-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="font-semibold">Approved</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Approved;
